import * as XLSX from 'xlsx';

export const exportToExcel = (
  data: any[],
  columns: string[],
  columnHeaders?: Record<string, string>,
  filename = 'export.xlsx',
) => {
  if (!data || data.length === 0) {
    console.warn('No data to export.');
    return;
  }

  const formattedData = data.map((item) => {
    const row: any = {};
    columns.forEach((key) => {
      const header = columnHeaders?.[key] || key;
      const value = item[key];
      row[header] = value === null || value === undefined ? '' : Array.isArray(value) ? 'Multiple values' : value;
    });
    return row;
  });

  const worksheet = XLSX.utils.json_to_sheet(formattedData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
  XLSX.writeFile(workbook, filename);
};
